"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SVGIcon_1 = require("./SVGIcon");
exports.default = SVGIcon_1.default;
//# sourceMappingURL=index.js.map